function slideFrom(direction, _value = 8) {
  const isX = direction === "left" || direction === "right";
  const isMinus = direction === "left" || direction === "top";
  const property = isX ? "x" : "y";
  const value = _value * (isMinus ? -1 : 1);
  return {
    initial: "initial",
    animate: "animate",
    exit: "exit",
    variants: {
      initial: {
        opacity: 0,
        [property]: value
      },
      animate: {
        opacity: 1,
        [property]: 0
      },
      exit: {
        opacity: 0,
        [property]: value
      }
    },
    transition: {
      duration: 0.15,
      type: "spring",
      bounce: 0
    }
  };
}
function scaleFrom(size) {
  const scale = size === "small" ? 0.95 : 1.05;
  return {
    initial: "initial",
    animate: "animate",
    exit: "exit",
    variants: {
      initial: {
        opacity: 0,
        scale
      },
      animate: {
        opacity: 1,
        scale: 1
      },
      exit: {
        opacity: 0,
        scale
      }
    },
    transition: {
      duration: 0.24,
      type: "spring",
      bounce: 0
    }
  };
}
const ease = {
  springOut: [0.175, 0.885, 0.32, 1.2],
  springIn: [0.7, 0, 0.84, 0],
  easeIn: [0.7, 0, 0.3, 1],
  easeOut: [0, 0.3, 0.3, 1],
  easeInOut: [0.65, 0, 0.35, 1],
  easeOutExpo: [0.16, 1, 0.3, 1],
  easeInExpo: [0.7, 0, 0.84, 0]
};

export { ease, scaleFrom, slideFrom };
//# sourceMappingURL=animations.mjs.map
